import * as types from "./types";

export const getActivityLogsRequest = (payload) => ({
  type: types.GET_ACTIVITY_LOGS_REQUEST,
  payload,
});

export const getActivityLogsResponse = (payload) => ({
  type: types.GET_ACTIVITY_LOGS_RESPONSE,
  payload,
});

export const getActivityLogsFailure = () => ({
  type: types.GET_ACTIVITY_LOGS_FAILURE,
});
